export default "__VITE_ASSET__B$66PQVm__"